export default "__VITE_PUBLIC_ASSET__896db6b3__"